import React, { useState, createContext, useContext, useEffect, useCallback } from "react";
import { useLocation } from "react-router-dom";
import environment from "../env";
import axios from "axios";

export interface AnnouncementContext {
    announcement?: string | null;
    refreshAnnouncement: () => Promise<void>;
    bannerHeight: number;
    setBannerHeight: (height: number) => void;
}

const Context = createContext<AnnouncementContext>(null!);

export function AnnouncementContextProvider(props: React.PropsWithChildren<{}>) {
    const [announcement, setAnnouncement] = useState<string | null>(null);
    const [bannerHeight, setBannerHeight] = useState<number>(0);
    const location = useLocation();

    const refreshAnnouncement = useCallback(async () => {
        try {
            const response = await axios.get(`${environment.newApiUrl}announcement`);
            setAnnouncement(response.data?.announcement ?? null);
        } catch (error) {
            console.error("Failed to fetch announcement:", error);
            setAnnouncement(null);
        }
    }, []);

    useEffect(() => {
        refreshAnnouncement();
    }, [location.pathname, refreshAnnouncement]);

    return (
        <Context.Provider value={{ announcement, refreshAnnouncement, bannerHeight, setBannerHeight }}>
            {props.children}
        </Context.Provider>
    );
}

export function useAnnouncementContext() {
    return useContext(Context);
}